import { Pagination } from '../../type';
import {
  RenewalReview,
  RenewalReviewType,
  ReviewItem,
} from '../../type/review';
import { deleteCall, get, patch, post } from '../axios';

import { CreateReviewDto } from './dto/create-review-dto';
import { UpdateReviewDto } from './dto/update-review.dto';

export const getReviewsAverageRating = () => {
  return get('/reviews/rating');
};

export const getReviewsRating = (productId?: number) => {
  return get(`/reviews/ratings-count?productId=${productId}`);
};

export const getReviewById = async (id: number) => {
  const { data } = await get<RenewalReview>(`/reviews/${id}`);
  return data;
};

export const createReview = (data: CreateReviewDto) => {
  return post('/reviews', data);
};

export const deleteReview = (id: number) => {
  return deleteCall(`/reviews/${id}`);
};

export const updateReview = (id: number, data: UpdateReviewDto) => {
  return patch(`/reviews/${id}`, {
    rating: data.rating,
    content: data.content,
    photos: data.photos,
  });
};

export const getMyReview = () => {
  return get('/reviews/me');
};

export const getReviewsByReviewType = async (
  type: RenewalReviewType,
  page: number,
  pageSize: number,
  createdAt?: string,
) => {
  const { data } = await get<Pagination<ReviewItem>>(
    `/subscription/review?type=${type}&page=${page}&pageSize=${pageSize}${
      Boolean(createdAt?.length) ? `&createdAt=${createdAt}` : ''
    }`,
  );
  return data;
};

export type GetReviewsOrderBy = 'createdAt' | 'rating' | 'purchaseCount';
export type ReviewType = 'subscription' | 'ustore' | 'all';
export interface GetUstoreReviewReqDto {
  productId: number;
  page: number;
  pageSize: number;
  photoRequired: boolean;
  rating?: number;
  type?: ReviewType;
  orderBy?: GetReviewsOrderBy;
}

export const getUstoreReview = async ({
  photoRequired,
  ...rest
}: GetUstoreReviewReqDto) => {
  const data = await get<Pagination<RenewalReview>>('reviews', {
    params: {
      ...rest,
      photoRequired: photoRequired ? 'true' : 'false',
    },
  });

  return data;
};
